import React, { useEffect, useState } from 'react';
import api from '../api';
import './PageTable.css';

function Songs() {
  const [songs, setSongs] = useState([]);
  const [platforms, setPlatforms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [assignModal, setAssignModal] = useState(null);
  const [platformId, setPlatformId] = useState('');
  const [platformUrl, setPlatformUrl] = useState('');

  const [detailSong, setDetailSong] = useState(null);
  const [editForm, setEditForm] = useState(null);
  const [saving, setSaving] = useState(false);
  const [earningsForm, setEarningsForm] = useState({});
  const [artists, setArtists] = useState([]);
  const [createModal, setCreateModal] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [createForm, setCreateForm] = useState({ artist_id: '', title: '', artwork_url: '', genre: '', release_date: '', lyrics: '', composer: '', arranger: '' });
  const handleArtworkUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('photo', file);
      const res = await api.post('/admin-upload/image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setCreateForm((f) => ({ ...f, artwork_url: res.data.url }));
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal upload artwork');
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  const fetchAll = async () => {
    setLoading(true);
    try {
      const [songsRes, platformsRes] = await Promise.all([
        api.get('/songs/admin/all'),
        api.get('/songs/platforms/list'),
      ]);
      setSongs(songsRes.data);
      setPlatforms(platformsRes.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchArtists = async () => {
    try {
      const res = await api.get('/artists/public?limit=100');
      setArtists(res.data.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchAll();
    fetchArtists();
  }, []);

  const updateStatus = async (id, status) => {
    try {
      await api.patch(`/songs/admin/${id}/status`, { status });
      await fetchAll();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal update status lagu');
    }
  };

  const submitCreateSong = async (e) => {
    e.preventDefault();
    try {
      await api.post('/songs/admin', createForm);
      setCreateModal(false);
      setCreateForm({ artist_id: '', title: '', artwork_url: '', genre: '', release_date: '', lyrics: '', composer: '', arranger: '' });
      await fetchAll();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal membuat lagu');
    }
  };

  const [editPlatformUrls, setEditPlatformUrls] = useState({});

  const openAssignModal = async (song) => {
    try {
      const res = await api.get(`/songs/admin/${song.id}`);
      setAssignModal(res.data);
      setPlatformId('');
      setPlatformUrl('');
      const urlMap = {};
      (res.data.platforms || []).forEach((p) => { urlMap[p.id] = p.platform_url || ''; });
      setEditPlatformUrls(urlMap);
    } catch (err) {
      alert('Gagal memuat data platform lagu');
    }
  };

  const submitAssign = async (e) => {
    e.preventDefault();
    if (!platformId) {
      alert('Pilih platform dulu');
      return;
    }
    try {
      await api.post(`/songs/admin/${assignModal.id}/platforms`, {
        platform_id: platformId,
        platform_url: platformUrl,
      });
      await openAssignModal(assignModal);
      await fetchAll();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal assign platform');
    }
  };

  const saveUrl = async (songPlatformId) => {
    try {
      await api.put(`/songs/admin/platforms/${songPlatformId}`, { platform_url: editPlatformUrls[songPlatformId] });
      alert('URL platform berhasil disimpan');
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal update URL');
    }
  };

  const removePlatform = async (songPlatformId) => {
    if (!window.confirm('Hapus platform ini dari lagu?')) return;
    try {
      await api.delete(`/songs/admin/platforms/${songPlatformId}`);
      await openAssignModal(assignModal);
      await fetchAll();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal menghapus platform');
    }
  };

  const openDetail = async (id) => {
    try {
      const res = await api.get(`/songs/admin/${id}`);
      setDetailSong(res.data);
      setEditForm({
        title: res.data.title || '',
        genre: res.data.genre || '',
        description: res.data.description || '',
        tags: res.data.tags || '',
        lyrics: res.data.lyrics || '',
        composer: res.data.composer || '',
        arranger: res.data.arranger || '',
        original_release_year: res.data.original_release_year || '',
        isrc_code: res.data.isrc_code || '',
        release_date: res.data.release_date ? res.data.release_date.slice(0, 10) : '',
        artwork_url: res.data.artwork_url || '',
      });
    } catch (err) {
      alert('Gagal memuat detail lagu');
    }
  };

  const closeDetail = () => {
    setDetailSong(null);
    setEditForm(null);
  };

  const saveEdit = async () => {
    setSaving(true);
    try {
      await api.put(`/songs/admin/${detailSong.id}`, editForm);
      await fetchAll();
      closeDetail();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal menyimpan perubahan');
    } finally {
      setSaving(false);
    }
  };

  const submitEarnings = async (songPlatformId) => {
    const form = earningsForm[songPlatformId];
    if (!form?.month || !form?.year || !form?.amount) {
      alert('Isi bulan, tahun, dan jumlah dulu');
      return;
    }
    try {
      await api.post(`/songs/admin/platforms/${songPlatformId}/earnings`, {
        period_month: form.month,
        period_year: form.year,
        amount: form.amount,
      });
      await openDetail(detailSong.id);
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal input earnings');
    }
  };

  return (
    <div>
      <div className="page-header-row">
        <h1 className="page-title" style={{ marginBottom: 0 }}>Rilis / Songs</h1>
        <button className="btn-primary" onClick={() => setCreateModal(true)}>+ Tambah Lagu (untuk Artis)</button>
      </div>
      {loading ? (
        <p>Memuat...</p>
      ) : (
        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                <th>Judul</th>
                <th>Artis</th>
                <th>Genre</th>
                <th>Status</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {songs.map((s) => (
                <tr key={s.id}>
                  <td>
                    <button onClick={() => openDetail(s.id)} style={{ background: 'none', border: 'none', color: '#C9A66B', cursor: 'pointer', textDecoration: 'underline', padding: 0, font: 'inherit' }}>
                      {s.title}
                    </button>
                  </td>
                  <td>{s.artist_name}</td>
                  <td>{s.genre || '-'}</td>
                  <td><span className={`status-badge status-${s.status}`}>{s.status}</span></td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className="btn-approve"
                        disabled={s.status === 'approved'}
                        onClick={() => updateStatus(s.id, 'approved')}
                      >
                        Approve
                      </button>
                      <button
                        className="btn-reject"
                        disabled={s.status === 'rejected'}
                        onClick={() => updateStatus(s.id, 'rejected')}
                      >
                        Reject
                      </button>
                      <button className="btn-edit" onClick={() => openAssignModal(s)}>
                        Kelola Platform
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {songs.length === 0 && (
                <tr>
                  <td colSpan="5" style={{ textAlign: 'center', color: '#888' }}>
                    Belum ada lagu
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {createModal && (
        <div className="modal-overlay" onClick={() => setCreateModal(false)}>
          <form className="modal-box" onClick={(e) => e.stopPropagation()} onSubmit={submitCreateSong} style={{ maxHeight: '85vh', overflowY: 'auto' }}>
            <h2>Tambah Lagu untuk Artis</h2>
            <select
              value={createForm.artist_id}
              onChange={(e) => setCreateForm({ ...createForm, artist_id: e.target.value })}
              required
            >
              <option value="">-- Pilih Artis --</option>
              {artists.map((a) => (
                <option key={a.id} value={a.id}>{a.name}</option>
              ))}
            </select>
            <input
              type="text"
              placeholder="Judul lagu"
              value={createForm.title}
              onChange={(e) => setCreateForm({ ...createForm, title: e.target.value })}
              required
            />
            <input
              type="url"
              placeholder="URL artwork/cover"
              value={createForm.artwork_url}
              onChange={(e) => setCreateForm({ ...createForm, artwork_url: e.target.value })}
            />
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 6, marginBottom: 8 }}>
              <label style={{ display: 'inline-block', fontSize: 13, color: '#C9A66B', border: '1px solid #C9A66B', padding: '6px 14px', borderRadius: 6, cursor: 'pointer' }}>
                {uploading ? 'Mengupload...' : '📁 Upload dari Perangkat'}
                <input type="file" accept="image/jpeg,image/png,image/webp" onChange={handleArtworkUpload} disabled={uploading} style={{ display: 'none' }} />
              </label>
              {createForm.artwork_url && (
                <div style={{ width: 36, height: 36, borderRadius: 4, overflow: 'hidden', background: '#303034' }}>
                  <img src={createForm.artwork_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={(e) => { e.target.style.display = 'none'; }} />
                </div>
              )}
            </div>
            <input
              type="text"
              placeholder="Genre"
              value={createForm.genre}
              onChange={(e) => setCreateForm({ ...createForm, genre: e.target.value })}
            />
            <label style={{ fontSize: 12, color: '#888' }}>Tanggal Rilis</label>
            <input
              type="date"
              value={createForm.release_date}
              onChange={(e) => setCreateForm({ ...createForm, release_date: e.target.value })}
            />
            <input
              type="text"
              placeholder="Pencipta Lagu (Composer)"
              value={createForm.composer}
              onChange={(e) => setCreateForm({ ...createForm, composer: e.target.value })}
            />
            <input
              type="text"
              placeholder="Arranger"
              value={createForm.arranger}
              onChange={(e) => setCreateForm({ ...createForm, arranger: e.target.value })}
            />
            <textarea
              placeholder="Lirik (opsional)"
              rows={4}
              value={createForm.lyrics}
              onChange={(e) => setCreateForm({ ...createForm, lyrics: e.target.value })}
            />
            <p style={{ fontSize: 12, color: '#888' }}>Lagu yang dibuat admin otomatis berstatus "approved".</p>
            <div className="modal-actions">
              <button type="button" className="btn-secondary" onClick={() => setCreateModal(false)}>Batal</button>
              <button type="submit" className="btn-primary">Simpan</button>
            </div>
          </form>
        </div>
      )}

      {assignModal && (
        <div className="modal-overlay" onClick={() => setAssignModal(null)}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()} style={{ maxHeight: '85vh', overflowY: 'auto' }}>
            <h2>Kelola Platform — {assignModal.title}</h2>

            {assignModal.platforms && assignModal.platforms.length > 0 ? (
              <div style={{ marginBottom: 16 }}>
                <p style={{ fontSize: 12, color: '#888', marginBottom: 8 }}>Sudah ter-upload di:</p>
                {assignModal.platforms.map((p) => (
                  <div key={p.id} style={{ display: 'flex', gap: 6, marginBottom: 8, alignItems: 'center' }}>
                    <span style={{ fontSize: 13, width: 80, flexShrink: 0, color: '#C9A66B' }}>{p.platform_name}</span>
                    <input
                      type="url"
                      placeholder="URL lagu di platform ini"
                      value={editPlatformUrls[p.id] || ''}
                      onChange={(e) => setEditPlatformUrls({ ...editPlatformUrls, [p.id]: e.target.value })}
                      style={{ flex: 1 }}
                    />
                    <button type="button" className="btn-primary" onClick={() => saveUrl(p.id)} style={{ padding: '8px 12px' }}>Simpan</button>
                    <button type="button" className="btn-delete" onClick={() => removePlatform(p.id)} style={{ padding: '8px 12px' }}>Hapus</button>
                  </div>
                ))}
              </div>
            ) : (
              <p style={{ fontSize: 13, color: '#888', marginBottom: 16 }}>Belum ada platform yang di-assign untuk lagu ini.</p>
            )}

            <form onSubmit={submitAssign} style={{ borderTop: '1px solid #333', paddingTop: 16 }}>
              <p style={{ fontSize: 12, color: '#888', marginBottom: 8 }}>+ Tambah platform baru:</p>
              <select value={platformId} onChange={(e) => setPlatformId(e.target.value)} required>
                <option value="">Pilih platform</option>
                {platforms.map((p) => (
                  <option key={p.id} value={p.id}>{p.name}</option>
                ))}
              </select>
              <input
                type="url"
                placeholder="URL lagu di platform tersebut"
                value={platformUrl}
                onChange={(e) => setPlatformUrl(e.target.value)}
              />
              <div className="modal-actions">
                <button type="button" className="btn-secondary" onClick={() => setAssignModal(null)}>Tutup</button>
                <button type="submit" className="btn-primary">Tambah Platform</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {detailSong && editForm && (
        <div className="modal-overlay" onClick={closeDetail}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 640, maxHeight: '85vh', overflowY: 'auto' }}>
            <h2>Detail Lagu: {detailSong.title}</h2>
            <p style={{ fontSize: 13, color: '#888', marginTop: -8, marginBottom: 16 }}>
              Artis: <b>{detailSong.artist_name}</b>
            </p>

            <label style={{ display: 'block', fontSize: 13, color: '#aaa', marginBottom: 4 }}>Judul Lagu</label>
            <input type="text" value={editForm.title} onChange={(e) => setEditForm({ ...editForm, title: e.target.value })} />

            <label style={{ display: 'block', fontSize: 13, color: '#aaa', margin: '10px 0 4px' }}>URL Artwork</label>
            <input type="url" value={editForm.artwork_url} onChange={(e) => setEditForm({ ...editForm, artwork_url: e.target.value })} />

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, margin: '10px 0' }}>
              <div>
                <label style={{ display: 'block', fontSize: 13, color: '#aaa', marginBottom: 4 }}>Genre</label>
                <input type="text" value={editForm.genre} onChange={(e) => setEditForm({ ...editForm, genre: e.target.value })} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 13, color: '#aaa', marginBottom: 4 }}>Tanggal Rilis</label>
                <input type="date" value={editForm.release_date} onChange={(e) => setEditForm({ ...editForm, release_date: e.target.value })} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 13, color: '#aaa', marginBottom: 4 }}>Pencipta Lagu (Composer)</label>
                <input type="text" value={editForm.composer} onChange={(e) => setEditForm({ ...editForm, composer: e.target.value })} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 13, color: '#aaa', marginBottom: 4 }}>Arranger / Pencipta Musik</label>
                <input type="text" value={editForm.arranger} onChange={(e) => setEditForm({ ...editForm, arranger: e.target.value })} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 13, color: '#aaa', marginBottom: 4 }}>Tahun Rilis Asli</label>
                <input type="number" value={editForm.original_release_year} onChange={(e) => setEditForm({ ...editForm, original_release_year: e.target.value })} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 13, color: '#aaa', marginBottom: 4 }}>Kode ISRC</label>
                <input type="text" value={editForm.isrc_code} onChange={(e) => setEditForm({ ...editForm, isrc_code: e.target.value })} />
              </div>
            </div>

            <label style={{ display: 'block', fontSize: 13, color: '#aaa', margin: '10px 0 4px' }}>Tag (pisahkan koma)</label>
            <input type="text" value={editForm.tags} onChange={(e) => setEditForm({ ...editForm, tags: e.target.value })} />

            <label style={{ display: 'block', fontSize: 13, color: '#aaa', margin: '10px 0 4px' }}>Deskripsi</label>
            <textarea rows={2} value={editForm.description} onChange={(e) => setEditForm({ ...editForm, description: e.target.value })} />

            <label style={{ display: 'block', fontSize: 13, color: '#aaa', margin: '10px 0 4px' }}>Lirik</label>
            <textarea rows={6} value={editForm.lyrics} onChange={(e) => setEditForm({ ...editForm, lyrics: e.target.value })} />

            <div className="modal-actions" style={{ marginTop: 16 }}>
              <button type="button" className="btn-secondary" onClick={closeDetail}>Tutup</button>
              <button type="button" className="btn-primary" onClick={saveEdit} disabled={saving}>
                {saving ? 'Menyimpan...' : 'Simpan Perubahan'}
              </button>
            </div>

            {detailSong.platforms && detailSong.platforms.length > 0 && (
              <div style={{ marginTop: 24, borderTop: '1px solid #333', paddingTop: 16 }}>
                <h3 style={{ marginBottom: 12 }}>Platform & Earnings</h3>
                {detailSong.platforms.map((p) => (
                  <div key={p.id} style={{ marginBottom: 14, padding: 12, border: '1px solid #333', borderRadius: 6 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                      <b>{p.platform_name}</b>
                      <span style={{ color: '#C9A66B' }}>Total: Rp {Number(p.total_earnings).toLocaleString('id-ID')}</span>
                    </div>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <input
                        type="number"
                        placeholder="Bulan (1-12)"
                        style={{ width: 90 }}
                        onChange={(e) => setEarningsForm({ ...earningsForm, [p.id]: { ...earningsForm[p.id], month: e.target.value } })}
                      />
                      <input
                        type="number"
                        placeholder="Tahun"
                        style={{ width: 90 }}
                        onChange={(e) => setEarningsForm({ ...earningsForm, [p.id]: { ...earningsForm[p.id], year: e.target.value } })}
                      />
                      <input
                        type="number"
                        placeholder="Jumlah Rp"
                        style={{ flex: 1 }}
                        onChange={(e) => setEarningsForm({ ...earningsForm, [p.id]: { ...earningsForm[p.id], amount: e.target.value } })}
                      />
                      <button type="button" className="btn-primary" onClick={() => submitEarnings(p.id)}>Simpan</button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Songs;
